import { IDeserialize } from "./abstraction/IDeserialize";
import { ContractDocument } from "./ContractDocument";
import { ContractLine } from "./ContractLine";
import { ContractNote } from "./ContractNote";

export class Contract implements IDeserialize<Contract> {
  actualService: string;
  amount: number;
  berPercentage: number;
  comments: string;
  companyId: string;
  contractItem: string;
  contractManDays: number;
  contractReference: string;
  documents: ContractDocument[];
  endDate: Date;
  isActive: boolean;
  isDecrement: boolean;
  isDefault: boolean;
  isReverseBer: boolean;
  lines: ContractLine[];
  name: string;
  notes: ContractNote[];
  paymentTerms: string;
  poNumber: string;
  priceList: number;
  productSold: string;
  startDate: Date;
  type: string;
  isExpired: boolean;
  workType: string;

  deserialize(contract: Contract): Contract {
    Object.assign(this, contract);

    this.amount = Math.round((this.amount + Number.EPSILON) * 100) / 100;

    return this;
  }
}
